<template>
	<div class="affairs flex-wrap">
		<AffairsSection
			:taskList="taskList"
			@addTask="onAddTask"
			@editTask="onEditTask"
			@assignToManager="onAssignToManager"
		/>
		<SimpleCalendar
			style="flex-grow: 1; margin-left: 2rem"
			:taskList="taskList"
			@addTask="onAddTask"
			@editTask="onEditTask"
		/>
		<!-- ADD EVENT -->
		<vs-prompt
			@cancel="task.startDate = ''"
			@accept="tryAddTask()"
			:active.sync="activePromptAddEvent"
			:title="$t('addTask')"
			:acceptText="$t('save')"
			:cancelText="$t('cancel')"
		>
			<div class="con-exemple-prompt mb-4">
				<vx-input-group class="mb-3">
					<div
						class="vs-component vs-con-input-label vs-input vs-input-primary"
					>
						<label class="vs-input--label">{{ $t('chooseDate') }}</label>
						<div class="vs-con-input"></div>
						<vs-datepicker
							v-model="task.startDate"
							format="dd.MM.yyyy"
							v-validate="'required'"
							:to="minDate"
							name="date"
							type="datetime"
							:key="'createAffairPopupDate' + createAffairPopupKey"
						></vs-datepicker>
					</div>
					<span v-if="errors.first('date')" class="text-danger text-sm">
						{{ $t('fieldFilledIncorrect') }}
					</span>
				</vx-input-group>
				<div class="vs-component vs-con-input-label vs-input vs-input-primary ">
					<label class="vs-input--label">{{ $t('description') }}</label>
					<div class="vs-con-input"></div>
					<vs-textarea
						v-model="task.description"
						name="about"
						v-validate="'required|min:3|max:300'"
						rows="4"
						class="mb-0"
						:key="'createAffairPopupDateText' + createAffairPopupKey"
					/>
				</div>
				<span v-if="errors.first('about')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
		</vs-prompt>

		<vs-popup classContent="create-appeal" class="primary-popup" :title="$t('taskView')" :active.sync="activePromptEditEvent">
			<div class="my-4">
				<b>{{$t('date')}}</b>
				<p>{{taskDueDate}}</p>
			</div>
			<div v-if="task && task.order && task.order.id" class="my-4">
				<b>{{ $t('ticket') }}</b>
				<p>
					<RouterLink :to="`/ticket/${task.order.id}`">
						<span @click.stop="activePromptEditEvent = false">
							{{ task.order.id }}
						</span>
					</RouterLink>
				</p>
			</div>
			<div v-if="task.role === 'manager'" class="my-4">
				<b>{{ $t('manager') }}</b>
				<p>
					<RouterLink :to="`/manager/${task.userId}`" target="_blank">
						<span @click.stop="activePromptEditEvent = false">
							{{ task.fioUser }}
						</span>
					</RouterLink>
				</p>
			</div>
			<div class="my-4">
				<b>{{ $t('description') }}</b>
				<p>{{task.description}}</p>
			</div>
			<div class="buttons-block" style="display: flex; justify-content: flex-end;">
				<vs-button
					v-if="canShowAssignButton"
					style="margin-right: 1rem;"
					@click="showAssignTaskToManager"
					color="primary"
				>{{ $t('assign') }}</vs-button>

				<vs-button
					v-if="$store.getters['isAdmin'] ||  !task.is_by_admin"
					style="margin-right: 1rem;"
					@click="removeTask"
					color="danger"
				>{{ $t('delete') }}</vs-button>

				<vs-button
					v-if="canShowDoneButton"
					color="success"
					@click="setTaskCompleted(task), activePromptEditEvent = false"
				>{{ $t('done') }}</vs-button>
			</div>
		</vs-popup>

		<vs-prompt
			class="assign-manager-to-task"
			:title="$t('chooseManager')"
			:accept-text="$t('assign')"
			:cancel-text="$t('cancel')"
			@accept="assignToManager"
			:is-valid="!!assignedManager"
			:active.sync="activePromptAssignToManager">
			<div class="my-4">

			</div>
			<v-select
				v-model="assignedManager"
				:placeholder="$t('chooseManager')"
				name="area"
				:options="managersList.map(item => buildManagerForSelect(item))"
				:label="'username'"
				:dir="$vs.rtl ? 'rtl' : 'ltr'"
			/>
		</vs-prompt>
	</div>
</template>

<script>
import SimpleCalendar from "@/components/affairs/SimpleCalendar";
import AffairsSection from "@/components/affairs/AffairsSection";
import calendarEventsMixin from "@/mixins/calendarEvents"
import vSelect from 'vue-select'
import axios from '@/axios'
import moment from "moment";

export default {
	mixins: [calendarEventsMixin],
	name: "Affairs",
	components: {
		SimpleCalendar,
		AffairsSection,
		vSelect,
	},
	data() {
		return {
			activePromptAddEvent: false
		};
	},
	computed: {
		canShowAssignButton() {
			return this.$store.getters['isAdmin']
				&& !this.task.is_by_admin
				&& !this.task.is_completed;
		},
		canShowDoneButton() {
			return !this.task.is_completed;
		},
		minDate() {
			return new Date();
		},
		taskDueDate() {
			return moment(this.task.startDate).format("YYYY.MM.DD HH:mm");
		},
		taskList() {
			return this.filterTasks(this.$store.getters['calendar/getEvents']);
		}
	},
	methods: {
		filterTasks(list) {
			const currentDate = moment(new Date()).format("YYYY-MM-DD");
			return list.filter(item => 
				(!((item.date_time < currentDate && item.is_completed) || (item.date_time < currentDate && item.isNotRelevant))
				|| (this.filter && item.is_completed && item.isNotRelevant))
			);
		},
		async tryAddTask() {
			this.activePromptAddEvent = true;
			this.activePromptAddEvent = !(await this.addTask());
		}
	},
	async created() {
		await this.$store.dispatch('calendar/fetchEvents')
		if(this.$store.getters['isAdmin']){
			try {
			let res = 	await axios.get('admin/manager')
				if(res.status===200) this.managersList = res.data.data;
			}
			catch(e){
				console.error(e)
			}
		}
	}
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/vuexy/variables.scss";

.affairs {
	display: flex;
	width: 100%;

	.buttons-block{
		display: flex;
		justify-content: flex-end;
	}
}

.con-exemple-prompt {
	.append-text {
		height: 2.7rem;
	}
	.vs-button {
		border-left: 0;
	}
	.vx-input-group-append {
		align-items: flex-end;
	}
	.vs-input {
		width: 100%;
		textarea {
			resize: none;
		}
	}
}
</style>
